import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import { IonContent, IonPage } from "@ionic/react";
import { useLocation } from "react-router-dom";
import CommonHeader from "../../../CommonHeader";
import NavigoServices from "../../../services/NavigoServices";
import useUnhidePageOnEnter from "../../../hooks/useUnhidePageOnEnter";

SwiperCore.use([Pagination]);
export default function KnowYourPlan() {
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const pageRef = useUnhidePageOnEnter();
  const location = useLocation();
  const navigoStore = useSelector((store) => store.navigo);
  const { plan } = navigoStore;
  const [plans, setPlans] = useState();
  const [selectedPlan, setSelectedPlan] = useState("");
  const [planId, setPlanId] = useState("");
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const user = useSelector((store) => store.login.user);
  const patientProfileId = user?.patientProfile?.id;
  const [isPB, setIsPB] = useState(false);
  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);

  useEffect(() => {
    if (patientProfileId) {
      fetchPlans(patientProfileId);
    }
  }, [patientProfileId]);

  const fetchPlans = (id) => {
    NavigoServices.getPlansByPatientId(id)
      .then((res) => {
        const planList = res.data || [];
        setPlans(planList);

        if (planList.length > 0) {
          setSelectedPlan(planList[0].name);
          setPlanId(planList[0].planId);
        }
      })
      .catch(() => {
        setPlans([]);
      });
  };

  const selectedPlanDetails = plans?.find((p) => p.planId === planId);

  return (
    <IonPage ref={pageRef}>
      <IonContent fullscreen style={{ "--background": "#F5F6FA" }}>
        {" "}
        <React.Fragment>
          {isPB && <CommonHeader />}
          <div className="navigo-booking-container">
            <div className="navigo-booking-container-back-button">
              <p>{"Know your plan"}</p>
            </div>
            <div
              className="border px-4 py-3 mx-4 mt-4 rounded cursor-pointer flex justify-between items-center bg-white shadow"
              onClick={() => setIsPlanModalOpen(true)}
            >
              <span className="font-semibold">Plan: {selectedPlan}</span>
              <svg
                className="w-4 h-4 text-gray-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.187l3.71-3.956a.75.75 0 111.08 1.04l-4.25 4.533a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            {isPlanModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-40 z-100 flex justify-center items-end">
                <div className="w-full bg-white rounded-t-2xl overflow-hidden max-h-[80vh] flex flex-col">
                  <div className="bg-[#E5E8F0] px-4 py-3 flex justify-between items-center border-b">
                    <span className="text-sm font-bold text-[#12194C]">
                      My Active Plans
                    </span>
                    <button
                      onClick={() => setIsPlanModalOpen(false)}
                      className="text-xl font-light text-[#12194C]"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="overflow-y-auto">
                    {plans.map((plan, index) => (
                      <div
                        key={index}
                        className="px-4 py-3 text-[#12194C] border-b cursor-pointer hover:bg-gray-50"
                        onClick={() => {
                          setPlanId(plan.planId);
                          setSelectedPlan(plan.name); // ✅ add this
                          setIsPlanModalOpen(false);
                        }}
                      >
                        {plan.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="navigo-booking-container-section-2">
              {selectedPlanDetails && (
                <>
                  {/* Image Card ONLY */}
                  <div className="mx-4 mt-6 bg-white rounded-2xl shadow-md overflow-hidden">
                    {selectedPlanDetails.mobileCover && (
                      <img
                        src={selectedPlanDetails.mobileCover}
                        alt="Plan Banner"
                        className="w-full h-auto object-cover"
                      />
                    )}
                  </div>

                  {/* Content OUTSIDE the card */}
                  <div className="mx-4 mt-6 ml-6">
                    <h2 className="text-base font-bold text-[#12194C] mb-3">
                      What’s included:
                    </h2>

                    {selectedPlanDetails.longDescription && (
                      <div
                        className="plan-description text-[#2E3566] text-[15px] leading-7"
                        dangerouslySetInnerHTML={{
                          __html: selectedPlanDetails.longDescription,
                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </React.Fragment>
      </IonContent>
    </IonPage>
  );
}
